import React, { useEffect } from "react";
import moment from "moment";
import { decoder, filterPayType, filterTree, filterOnAccount } from "../../../utils/decoder";
import { formatNum } from "../../../utils/constants";
import { Button, Drawer, Form, Input, Select } from "antd";
import { useModel } from "../../../models";
import { debounce } from "lodash";

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const AreaForm = ({ formInstance }) => {
    const [form] = Form.useForm();
    const [{ payTypeDict },] = useModel("cmDict");
    const [{ selectedDocument, documentMaterialList }, { settle, setSelectedDocument, setPaymentDrawerVisible, loadSo }] = useModel("saleSo");

    useEffect(() => {
        const payDate = moment().format("YYYY-MM-DD");
        const {
            saleCode,
            createTime,
            customerCode,
            customerName,
            aggregateAmount,
            paidAmount = 0,
            paymentMethod
        } = selectedDocument;
        form.setFieldsValue({
            saleCode,
            createTime,
            customerCode,
            customerName,
            payableAmount: aggregateAmount,
            payedAmount: paidAmount,
            payType: paymentMethod,
            payDate,
        });
        /*form.setFieldsValue({saleCode: selectedDocument.saleCode});
        form.setFieldsValue({createTime: selectedDocument.createTime});
        form.setFieldsValue({customerCode: selectedDocument.customerId});
        form.setFieldsValue({customerName: selectedDocument.customerName});
        form.setFieldsValue({payDate: moment().format("YYYY-MM-DD")});
        form.setFieldsValue({payableAmount: selectedDocument.aggregateAmount});
        form.setFieldsValue({payedAmount: 0});*/

    }, [selectedDocument]);


    const onFinish = debounce(() => {
        form.validateFields().then(data => {
            const { payType, payDesc } = data;
            // let { discount, favorableAmount } = formInstance?.().getFieldsValue();  //折扣， 优惠金额
            // let totalAmount = documentMaterialList.reduce((total, next) => { total += +formatNum(next.aggregateAmount); return total; }, 0);
            // console.log(totalAmount, discount, favorableAmount, totalAmount * (+discount / 100) - +favorableAmount);
            settle({
                showMsg: true,
                data: {
                    id: selectedDocument.id,
                    payTypeCode: payType,
                    // paidAmount: totalAmount * (+discount / 100) - +favorableAmount,
                    payDesc,
                }
            }).then(async ret => {
                /*if (ret) {
                    setSelectedDocument({
                        ...selectedDocument,
                        paidAmount: selectedDocument.receivableAmount,
                        paymentMethod: form.getFieldValue("payType")
                    });

                    setPaymentDrawerVisible(false)
                }*/
                const { id } = selectedDocument;
                await loadSo({ showMsg: true, data: id })
                setPaymentDrawerVisible(false)
            });
        })
    }, 600)

    const onClose = () => {
        setPaymentDrawerVisible(false)
    }
    return (
        <Form {...layout} form={form} name="control-hooks"
            onFinish={onFinish}>
            <Form.Item name="saleCode" label="销售单号">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="createTime" label="制单日期">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="customerCode" label="客户编码">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="customerName" label="客户名称">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payDate" label="结算日期">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payableAmount" label="应收金额">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payedAmount" label="已收金额">
                <Input disabled={true} />
            </Form.Item>
            {/*<Form.Item name="payAmount" label="本次收款" rules={[{required: true, message: '请输入本次付款金额',}]}>
                <Input/>
            </Form.Item>*/}
            <Form.Item name="payType" label="支付方式" rules={[{ required: true, message: '请选择支付方式', }]}>
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择支付方式"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    // 张家口
                    options={filterOnAccount(payTypeDict)}
                // 公司潍柴
                // options={payTypeDict}                    
                />
            </Form.Item>
            <Form.Item name="payDesc" label="备注" rules={[{ required: false }]}>
                <Input.TextArea />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    确定
                </Button>
                <Button htmlType="button" onClick={onClose} className="margin-left-8">
                    取消
                </Button>
            </Form.Item>
        </Form>
    );
}
export default function ({ formInstance, ...props }) {
    const [{ paymentDrawerVisible }, { setPaymentDrawerVisible }] = useModel("saleSo");
    return (
        <Drawer
            title="销售收款"
            placement="right"
            width={500}
            closable={true}
            onClose={() => {
                setPaymentDrawerVisible(false)
            }}
            visible={paymentDrawerVisible}
        >
            <AreaForm formInstance={formInstance} />
        </Drawer>
    )
}